module.exports = __webpack_public_path__ + "static/media/valid.ef7a0858.svg";